/**
 * @description message 组件，接口详见types.ts
 */
import message from './widgets/message';

import './index.scss';

export type {
  MessageConfig,
  MessageOptions,
  MessageType,
  MessagePosition,
} from './types';
export default message;
